import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ExportacaoLeadService } from 'src/app/services/exportacao-lead.service';

@Component({
    selector: 'app-exportacao-lead',
    templateUrl: './exportacao-lead.component.html',
    styleUrls: ['./exportacao-lead.component.css'],
    standalone: false
})
export class ExportacaoLeadComponent implements OnInit {
  @Output() concluido = new EventEmitter;

  form!: UntypedFormGroup;
  loading = false;

  validacaoData = (control: UntypedFormControl): { [s: string]: boolean } => {
    if (control.value && this.form.value.data_inicial && new Date(this.form.value.data_inicial) > new Date(control.value)) {
      return { invalid: true };
    }
    return {};
  };

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private exportacaoLeadService: ExportacaoLeadService
  ) { 
    this.form = this.newForm();
  }

  ngOnInit(): void {
  }

  newForm() {
    return new UntypedFormGroup({
      data_inicial: new UntypedFormControl('', [Validators.required]),
      data_final: new UntypedFormControl('', [Validators.required, this.validacaoData]),
    });
  }

  submit() {
    if (this.form.valid) {
      let id = this.message.loading('Processando...').messageId;
      this.loading = true;
      this.exportacaoLeadService.solicitar(this.form.value).subscribe((data: any) => {
        this.message.remove(id);
        this.loading = false;
        this.concluido.emit(true);
        this.message.success(data.message);
        this.form.reset();
      }, () => {
        this.message.remove(id);
        this.loading = false;
        this.message.error('Houve uma falha ao registrar sua solicitação, tente novamente mais tarde!');
      });
    } else {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
    }
  }

}
